import { Scrubber } from 'slate';

const allowedKeys: Array<string | RegExp> = [
  'type',
  'alignment',
  'attachment_display',
  'fontSize',
  'fontFamily',
  'media_position',
  'affinity',
  'pill_colorScheme',
  'table_cellVerticalAlign',
  'table_borderColor',
  'table_cellBackgroundColor',
  'embed_display',
  'code_language',
  // Annotation related keys
  'key',
  'kind',
  'recordType',
  'recordId',
];

const inAllowList = (key: string) => {
  return allowedKeys.some((candidate) => {
    if (typeof candidate === 'string') {
      return candidate === key;
    } else {
      return candidate.test(key);
    }
  });
};

Scrubber.setScrubber((key, value) => {
  if (!inAllowList(key) && typeof value === 'string') {
    return new Array(value.length).fill('X').join('');
  }

  return value;
});
